import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import './Notifications.scss';
import { createServiceRequestAPI } from 'app/services/api/home';
import { openNotificationWithIcon } from 'app/components/PopupNotification';
import CloseModalIcon from 'app/components/CloseModal';
const ServiceRequest = (props: any) => {
  const [serviceRequestContent, setServiceContent] = useState('');
  const [form] = Form.useForm<any>();

  const onSubmitServiceRequest = async () => {
    try {
      await form
        .validateFields()
        .then(async then => {
          const formValues = await form.getFieldsValue();
          const res = await createServiceRequestAPI(formValues?.serviceContent);
          openNotificationWithIcon('success', res?.message);
          props.onCancelModal();
          form.resetFields();
        })
        .catch(error => {
          if (error?.message) {
            openNotificationWithIcon('error', error?.message);
          }
        });
    } catch (error: any) {}
  };

  useEffect(() => {
    setTimeout(() => {
      const dialog = document.querySelector('.ant-modal[role="dialog"]');
      if (dialog) {
        dialog.setAttribute('id', 'dlg_notification');
      }
    }, 50);
  }, [props.isOpenServiceRequest]);

  return (
    <>
      <Modal
        className="modal-notification"
        closeIcon={<CloseModalIcon {...({ name: 'close-icons' } as any)} customId={'modal-notification'} />}
        destroyOnClose
        open={props.isOpenServiceRequest}
        onCancel={() => {
          props.onCancelModal();
          form.resetFields();
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          // onFinish={handleSubmit}
        >
          <div className="service-request">
            <div className="service-request__icon">
              <img src="./image/service-request-icon.svg" alt="service-request-icon" />
            </div>
            <div className="service-request__title" role="title">
              Service Request
            </div>
            <div className="service-request__description">
              Please enter the service request details being as specific as possible, up to a maximum of 3,200
              characters
            </div>
            <div className="service-request__content">
              <Form.Item
                name="serviceContent"
                htmlFor="change-password-modal__input--oldPassword"
                className="mr-10"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the Service Request',
                  },
                ]}
              >
                <Input
                  id="service-request__content__input"
                  className="service-request__content__input mr-10"
                  maxLength={3200}
                />
              </Form.Item>
              <Button
                type="primary"
                id="service-request__content__submit"
                className="service-request__content__submit"
                onClick={() => onSubmitServiceRequest()}
              >
                Submit
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default ServiceRequest;
